import {NavLink} from 'react-router-dom';
import {
    Box,
    Breadcrumbs,
} from '@mantine/core';

import {ProviderConnection} from '../types';
import config from '../config';

export const DetailPageNavigation = ({component}: { component: ProviderConnection }) => {

    const breadcrumbs = [
        {
            title: 'Home',
            href: '/dashboard',
        },
        {
            title: config.titles.plural,
            href: config.basePath,
        },
        // The tenant's own name for the connection — never the opaque,
        // account-embedding id.
        {title: component.displayName},
    ].map((item, index) => (
        <Box key={index}>
            {item.href ? <NavLink to={item.href}>{item.title}</NavLink> : item.title}
        </Box>
    ));

    return (
        <Box p={'xs'}><Breadcrumbs separator='→' mt='xs'>{breadcrumbs}</Breadcrumbs></Box>
    );
};
